import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ExternalPensionStatusComponent } from './external-pension-status.component';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { Subscription } from 'rxjs';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../../_infrastructure/Utils/UtilsService';

@Component({
    selector: 'work-abroad-table-edit',
    templateUrl: './work-abroad-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class WorkAbroadTableEditComponent extends TableEditBase<models.WorkAbroadVM> implements OnInit, OnDestroy{
  
  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];

  private mainSubscription: Subscription = new Subscription(); 
  constructor(@Inject(ExternalPensionStatusComponent) parent: Component, private modalService: ModalService,
    private commonDataService: CommonDataService, private utilsService: UtilsService) {
    super(parent, modalService);

    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.yesNo,
      DomainCodes.country
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.yesNo = this.utilsService.getDomainOfDomains(DomainCodes.yesNo, results).dimensions;
        this.countries = this.utilsService.getDomainOfDomains(DomainCodes.country, results).dimensions;
      })
    );


  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }
}
